<template>
  <div class="invisible">
    <Modal 
    class="newModal"
    class-name="invisible-drawer"
     v-model="showInDrawer"
      width="480" :mask-closable="false" @on-cancel="closeDrawer">
      <header class="inv-header">
        <div class="header-name">指标配置可见</div>
        <div class="header-switch ">
          <div class="switch-lable">全部可见</div>
          <i-Switch 
           @on-change="SwitchChange" 
          true-color="rgba(30, 142, 62, 1)"
           v-model="switch1" size="small" />
        </div>

      </header>
      <section>

        <div class="sec-item" v-for="(index,key) in list" :key="key">
          <div class="line-1 item-lable">{{index.name}}</div>
          <i-Switch 
          @on-change="itemChange" 
           true-value="是" false-value="否"  v-model="index.isShow" true-color="rgba(30, 142, 62, 1)" size="small" />
        </div>

      </section>
     
        <div class="drawer-footer" slot="footer">
                <Button type="primary" @click="submitForm('formValidate')" :loading="btnLoading">提交</Button>
               
                <Button style="margin-right: 8px" @click="closeDrawer">取消</Button>
            </div>
      
    </Modal>
  </div>
</template>

<script>

   import {updateByTenant} from '@/api/knowledge/lubtionment'
  export default {

    props: {
      showDrawer: {
        type: Boolean
      },
      fioption: {
        type: Array
      },
      iniobj:{
        type:Object
      },
      clearclick:{
        type:Function
      }
    },
    data() {
      return {
        switch1: false,
        showInDrawer: false,
        list: [],
        btnLoading:false
      }
    },

    mounted() {
      
    },
    watch: {
      showDrawer: {
        handler: function(newValue, oldValue) {
          if(newValue){
            this.init()
          }
          this.$nextTick(() => {
            this.showInDrawer = newValue;
          })
        },
        deep: true,
      },
     
    },
    methods: {
      SwitchChange(){
  
        let value=this.switch1
        if(value){
          this.list=this.list.map((item)=>{
            item.isShow="是"
            return item
          })
        }else{
          this.list=this.list.map((item)=>{
            item.isShow="否"
            return item
          })
        }
      },
      itemChange(){
        let obj= this.list.find((item)=>{
           return item.isShow=="否"
        })
        if(!obj){
            this.switch1=true
        }else{
          this.switch1=false
        }
      },
     async  submitForm(){
        this.btnLoading=true
        let data=await  updateByTenant({
          tenantId:this.iniobj.id,
          identifiers:this.list
        })

        this.btnLoading=false
        if(data.code=="00000"){
          this.$Message.success('设置成功');
          this.closeDrawer()
        }
     },
      init() {
        this.list = this.$c.deepClone(this.fioption)
       let obj= this.list.find((item)=>{
           return item.isShow=="否"
        })
        if(!obj){
            this.switch1=true
        }else{
          this.switch1=false
        }
      },
      change() {

      },
      closeDrawer() {
        
        this.clearclick()
        setTimeout(() => {
           this.list=[]
        }, 200);
        
      }
    }
  }
</script>




<style>
  .invisible-drawer .ivu-modal-header,
  .invisible-drawer .ivu-modal-footer {
    padding-left: 24px !important;
    border: none !important;

  }

  .invisible-drawer .ivu-modal-body {
    padding-left: 24px !important;
  }
</style>

<style lang='less'>
  .invisible-drawer {
    .inv-header {
      display: flex;
      align-items: center;

      .header-name {
        font-size: 16px;
  
        font-weight: 400;
        color: #111111;
      }

      .header-switch {
        margin-left: 16px;
        font-size: 12px;
  
        font-weight: 400;
        color: rgba(0, 0, 0, 0.851);
        display: flex;
        align-items: center;

        .switch-lable {
          margin-right: 4px;
        }
      }
    }

    section {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-top: 18px;

      .sec-item {
        width: 120px;
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        margin-right: 24px;

        .item-lable {
          width: 85px;
          font-size: 12px;
        
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
</style>